import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-entfernen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichEntfernenEffects {

    BereichEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_ENTFERNEN),
        mergeMap((x: ac.PostBereichEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichEntfernen(x.bereichRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichEntfernenErfolgreichAction(result, x.bereichRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichEntfernenFehlerAction(error, x.bereichRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
